import React from "react";
import "./App.css";
import { MainNavigation, Features, Contact, Team } from "./components";

function App() {
  return (
    <React.Fragment>
      <MainNavigation />
      <Features />
      <Team />
      <Contact />
    </React.Fragment>
  );
}

export default App;
